import React from 'react';
import { Box } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

const RequireJoinApprovalBadge = ({ required, inactiveLabel = 'No' }) => {
  if (!required) {
    return (
      <Box component="span" sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.primary' }}>
        {inactiveLabel}
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.1,
        py: 0.35,
        borderRadius: '999px',
        bgcolor: '#FFEDD5',
        color: '#C2410C',
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.4,
      }}
    >
      <PersonOutlineIcon sx={{ fontSize: 15 }} />
      Admin Approval Required
    </Box>
  );
};

export default RequireJoinApprovalBadge;
